var React = require('react');

function Delete (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M2.75 22.5a1.75 1.75 0 01-1.27-2.95l18-19A1.757 1.757 0 1122 3L4 22a1.72 1.72 0 01-1.25.5z","key":0}),React.createElement("path",{"d":"M19.75 22.5a1.75 1.75 0 01-1.24-.5L.51 4A1.76 1.76 0 013 1.51l18 18a1.75 1.75 0 01-1.24 3z","key":1})]);
}

Delete.defaultProps = {"className":"fill-current","viewBox":"0 0 22.5 22.5"};

module.exports = Delete;

Delete.default = Delete;
